import { render, staticRenderFns } from "./StudentCourseUnitList.vue?vue&type=template&id=350f5885&scoped=true"
import script from "./StudentCourseUnitList.vue?vue&type=script&lang=js"
export * from "./StudentCourseUnitList.vue?vue&type=script&lang=js"
import style0 from "./StudentCourseUnitList.vue?vue&type=style&index=0&id=350f5885&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350f5885",
  null
  
)

export default component.exports